// extracted by mini-css-extract-plugin
module.exports = {"root":"PresentationSlide_root__3nH2y"};